import { DateTime } from 'luxon'

export const CLOCK_SKEW_THRESHOLD_MS = 5 * 60 * 1000
export const CLOCK_RECHECK_EVENT = 'lobby:recheck-clock'

export const parseServerClock = (serverTime) => {
  if (!serverTime) return null
  const dt = DateTime.fromISO(String(serverTime).trim(), { setZone: true })
  return dt.isValid ? dt : null
}

export const isClockSkewed = (
  localDt,
  serverDt,
  thresholdMs = CLOCK_SKEW_THRESHOLD_MS
) => {
  if (!localDt?.isValid || !serverDt?.isValid) return false
  if (localDt.offset !== serverDt.offset) return true
  return Math.abs(localDt.toMillis() - serverDt.toMillis()) > thresholdMs
}

const formatClockLabel = (dt, { withDate = false } = {}) => {
  if (!dt?.isValid) return ''
  const fmt = withDate ? 'yyyy-MM-dd hh:mm a' : 'hh:mm a'
  return dt.setLocale('en-US').toFormat(fmt)
}

export const clockLabels = (localDt, serverDt) => {
  const withDate = Boolean(
    localDt?.isValid && serverDt?.isValid && localDt.toISODate() !== serverDt.toISODate()
  )
  return {
    local: formatClockLabel(localDt, { withDate }),
    expected: formatClockLabel(serverDt, { withDate }),
  }
}

export const evaluateClockSkew = ({
  serverTime,
  domain,
  localDt = DateTime.local(),
  thresholdMs = CLOCK_SKEW_THRESHOLD_MS,
} = {}) => {
  const tenant = domain == null ? '' : String(domain).trim()
  if (!tenant || tenant === 'public') {
    return { skewed: false, offsetMismatch: false, serverDt: null, localDt }
  }

  const serverDt = parseServerClock(serverTime)
  if (!serverDt) {
    return { skewed: false, offsetMismatch: false, serverDt: null, localDt }
  }

  const offsetMismatch = localDt.offset !== serverDt.offset
  return {
    skewed: isClockSkewed(localDt, serverDt, thresholdMs),
    offsetMismatch,
    serverDt,
    localDt,
  }
}
